import type { RouterHistory } from "@tanstack/history";

/** Only trust entries observed by this app, never browser history.length. */
export function trackSafeBackHistory(history: RouterHistory) {
  const entries = new Map<number, { key: string | undefined; href: string }>();
  const record = () => {
    const { state, href } = history.location;
    entries.set(state.__TSR_index, { key: state.__TSR_key, href });
  };
  record();
  const unsubscribe = history.subscribe(({ action, location }) => {
    if (action.type === "PUSH") {
      for (const index of entries.keys()) {
        if (index >= location.state.__TSR_index) entries.delete(index);
      }
    }
    record();
  });
  return {
    previousHref() {
      const { state } = history.location;
      const current = entries.get(state.__TSR_index);
      if (!current || current.key !== state.__TSR_key) return null;
      return entries.get(state.__TSR_index - 1)?.href ?? null;
    },
    unsubscribe,
  };
}